import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Text, Box, VStack } from '@chakra-ui/react';

const ModalConfirmacao = ({ isOpen, onClose, onConfirm, pergunta, resposta, isLoading }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Confirmar Envio de Resposta</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack align="start" spacing={4}>
                        <Text>Tem certeza que deseja enviar esta resposta?</Text>
                        <Box w="100%">
                            <Text fontSize="sm" fontWeight="bold">Pergunta:</Text>
                            <Text 
                                fontSize="sm" 
                                color="gray.700" 
                                p={2} 
                                bg="gray.100" 
                                borderRadius="md"
                                whiteSpace="pre-wrap"
                            >
                                {pergunta?.text}
                            </Text>
                        </Box>
                        <Box w="100%">
                            <Text fontSize="sm" fontWeight="bold">Sua Resposta:</Text>
                            <Text 
                                fontSize="sm" 
                                color="green.800" 
                                p={2} 
                                bg="green.50" 
                                borderRadius="md"
                                whiteSpace="pre-wrap"
                            >
                                {resposta}
                            </Text>
                        </Box>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={onClose} mr={3}>Cancelar</Button>
                    <Button colorScheme="green" onClick={onConfirm} isLoading={isLoading}>
                        Confirmar
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ModalConfirmacao;